export default __webpack_public_path__ + "static/media/ic-teachers.5667ccb1.svg";